module.exports = __webpack_public_path__ + "static/media/whatsapp.70684a12.png";